import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface ThemeState {
  theme: string;
}

const initialState: ThemeState = {
  theme: localStorage.getItem("theme") || "light",
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    makeLightTheme: (state) => {
      localStorage.setItem("theme", "light");
      state.theme = "light";
    },
    makeDarkTheme: (state) => {
      localStorage.setItem("theme", "dark");
      state.theme = "dark";
    },
  },
});

export const { makeDarkTheme, makeLightTheme } = themeSlice.actions;

export const selectTheme = (state: RootState) => state.theme.theme;

export default themeSlice.reducer;
